<nf-grid-wrapper [hideSearch]="true" [hideClearAll]="true">
  <nf-grid-wrapper-header-left>
    <h2 class="title">Clearwater</h2>
    <ng-container *ngIf="!_cacheLoaded">
      <span
        id="icon-alert"
        class="mdi mdi-alert-circle text-warning ml-1"
        ngbTooltip="Filter results may be incomplete as data is still loading."
        placement="right"
      ></span>
      <ngb-alert id="banner-alert" class="mb-0 py-0 pl-2 pr-4 ml-1">
        <strong class="mr-1"
          >Filter results may be incomplete as data is still loading.</strong
        >
      </ngb-alert>
    </ng-container>
  </nf-grid-wrapper-header-left>
  <ng-grid-wrapper-header-right class="d-flex">
    <div id="quickfilter-container" class="d-flex mr-2">
      <nf-checkbox
        class="small"
        [formControl]="hideFuturePostDatesToggle"
        label="Hide Future Post Dates"
      ></nf-checkbox>
      <nf-checkbox
        class="small"
        [formControl]="filterPostDateTodayToggle"
        label="Post Date Today"
      ></nf-checkbox>
      <nf-checkbox
        class="small"
        [formControl]="filterClearedToggle"
        label="Cleared"
      ></nf-checkbox>
      <nf-checkbox
        class="small"
        [formControl]="filterUnclearedToggle"
        label="Uncleared"
      ></nf-checkbox>
    </div>
  </ng-grid-wrapper-header-right>
  <ng-grid-wrapper-header-right
    class="d-flex"
    *ngIf="fxCurrencyFilteringToggle.value"
  >
    <nf-form-control class="d-flex mr-2" style="max-width: 8rem" compact>
      <ng-select
        placeholder="FX Currency"
        [formControl]="fxCurrencyFilter"
        [items]="fxCurrencyFilterItems"
        [multiple]="true"
        class="multi-select"
        [closeOnSelect]="false"
        clearAllText="Clear"
        [clearable]="true"
        [clearOnBackspace]="true"
      >
        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
          <div
            *ngIf="items.length > 1; else singleItem"
            class="ng-value nf-custom-badge"
          >
            <span class="ng-value-label"> {{ items.length }} selected </span>
          </div>
          <ng-template #singleItem>
            <div class="ng-value nf-custom-badge">
              <span
                class="ng-value-label"
                *ngFor="let item of items; index as i"
                >{{ item }}</span
              >
            </div>
          </ng-template>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <div container="body" class="ellipsis">
            {{ item }}
          </div>
        </ng-template>
      </ng-select>
    </nf-form-control>
  </ng-grid-wrapper-header-right>
  <ng-grid-wrapper-header-right
    ><nf-form-control class="d-flex mr-2" compact for="quickSearchAssetIds">
      <input
        type="text"
        class="form-control"
        [formControl]="quickSearchAssetIds"
        placeholder="Asset Ids (e.g. 1,2,3)"
      />
    </nf-form-control>
  </ng-grid-wrapper-header-right>
  <ng-grid-wrapper-header-right>
    <div ngbDropdown placement="bottom-right">
      <button
        nf-button="create"
        id="dropdown3"
        ngbDropdownToggle
        [title]="createUnlinkedTxTooltip"
        [disabled]="!anyCreatePermission"
      ></button>
      <div
        ngbDropdownMenu
        aria-labelledby="dropdown3"
        class="dropdown-menu dropdown-menu-right"
      >
        <button
          *ngFor="let createTxButton of createTxButtons"
          type="button"
          class="dropdown-item btn btn-link"
          (click)="createTxButton.onClick()"
          [disabled]="createTxButton.disabled"
          [ngbTooltip]="createTxButton.tooltip"
        >
          {{ createTxButton.name }}
        </button>
      </div>
    </div>
  </ng-grid-wrapper-header-right>
  <ng-grid-wrapper-header-right>
    <div ngbDropdown placement="bottom-right">
      <button
        ngbDropdownToggle
        nf-icon-button
        class="cw-actions-button"
        ngbTooltip="CW Transactions Actions"
        placement="bottom-right"
        icon="dots-vertical"
        style="margin-left: 8px"
      >
        Clearwater Transactions Actions
      </button>
      <div
        ngbDropdownMenu
        aria-labelledby="dropdown"
        class="dropdown-menu dropdown-menu-right"
      >
        <button
          type="button"
          class="dropdown-item btn btn-link"
          (click)="exportCWTranToExcel()"
        >
          Export to Excel
        </button>
      </div>
    </div>
  </ng-grid-wrapper-header-right>
  <ng-grid-wrapper-header-right>
    <button
      nf-icon-button="secondary"
      ngbTooltip="Filters Modal"
      placement="bottom-right"
      icon="filter"
      (click)="launchFiltersModal()"
      data-cy="advancedFiltersBtn"
    >
      Open Filters Modal
    </button>
    <hs-applied-filter-counts
      [filterCount]="filterCount"
    ></hs-applied-filter-counts>
  </ng-grid-wrapper-header-right>
  <ng-grid-wrapper-header-right>
    <button
      id="clear-all-filters-button"
      nf-icon-button="secondary"
      (click)="clearAllFilters()"
      icon="filter-remove"
      ngbTooltip="Clear All Filters"
      [disabled]="!clearAllFiltersEnabled"
      placement="bottom-right"
    >
      Clear all filters
    </button>
  </ng-grid-wrapper-header-right>
  <nf-grid-wrapper-content *ngIf="gridOptions$ | async as gridOptions">
    <nf-table-layout
      [hideTitle]="true"
      [isSectionTitle]="true"
      [gridOptions]="gridOptions"
      [modules]="gridModules"
      [autoResizeGrid]="false"
      hideSearch
      hideClearAll
    >
    </nf-table-layout>
  </nf-grid-wrapper-content>
</nf-grid-wrapper>
